var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('material-tabs',{attrs:{"tabs":_vm.tabs}},[_c('v-flex',{attrs:{"slot":"body","xs12":""},slot:"body"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }